import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ReactComponent as Dropdown } from "../../../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as RemoveMemberIcon } from "../../../../../assets/images/People/Teams/remove-member.svg";
import { colorCodesForAvatar } from "../../../../../constants/index";
import { chracterPosition } from "../../../../../utils/index";
import { TEAM_FORM_WIDTH } from "../teamFormStyles";
import {
  peopleSelectControlSx,
  peopleSelectMenuProps,
  peopleSelectSx,
} from "../../peopleSelectStyles";

const ROLE_OPTIONS = ["Admin", "Agent"];

function isSuperAdminMember(member) {
  return (
    member.role === "Super Admin" ||
    member.roleName === "admin_with_billing"
  );
}

export default function TeamEditMemberRow({ member, onRoleChange, onRemove, readOnly = false }) {
  const letter = (member.name || "").substring(0, 1).toUpperCase();
  const isSuperAdmin = isSuperAdminMember(member);
  const roleDisabled = readOnly || isSuperAdmin;
  const roleSelectWidth = isSuperAdmin ? 128 : 104;
  const roleSelectSx = peopleSelectControlSx({
    width: roleSelectWidth,
    minWidth: roleSelectWidth,
    flexShrink: 0,
  });

  return (
    <Box
      sx={{
        width: TEAM_FORM_WIDTH,
        maxWidth: "100%",
        minHeight: 72,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        py: 2,
        boxSizing: "border-box",
        borderBottom: "1px solid #EEF2F6",
      }}
    >
      <Avatar
        src={member.avatar || undefined}
        alt={member.name}
        imgProps={{ referrerPolicy: "no-referrer" }}
        sx={{
          width: 40,
          height: 40,
          fontSize: 14,
          bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
          flexShrink: 0,
        }}
      >
        {!member.avatar ? letter : null}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "18px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {member.name}
        </Typography>
        <Typography
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {member.email}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          height: 40,
        }}
      >
        <FormControl size="small" sx={roleSelectSx}>
          <Select
            value={member.role}
            disabled
            open={false}
            IconComponent={isSuperAdmin ? () => null : Dropdown}
            sx={{
              ...peopleSelectSx,
              "& .MuiSelect-select": {
                paddingRight: "16px !important",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
            renderValue={() => (
              <Typography
                component="span"
                noWrap
                sx={{ fontSize: 14, color: "#93A1B0" }}
              >
                {member.role}
              </Typography>
            )}
            // Remove all menu items: do not display any options
            MenuProps={{ ...peopleSelectMenuProps, MenuListProps: { style: { display: "none" } } }}
          />
 
        </FormControl>
        {!readOnly ? (
          <Box
            component="button"
            type="button"
            onClick={() => onRemove(member.id)}
            sx={{
              width: 40,
              height: 40,
              flexShrink: 0,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              p: 0,
              m: 0,
              lineHeight: 0,
              cursor: "pointer",
              "&:hover": { background: "#FFF", borderColor: "#C5CED6" },
            }}
          >
            <RemoveMemberIcon  />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
